export default {
  props: {
    teacherData: {
      required: true,
      defalut: {},
      type: Object
    }
  },
  methods: {
    openDetail() {
      let navItemInfo = JSON.parse(sessionStorage.getItem('authInfo'));
      let nav = navItemInfo.find(item => item.function_id == '18300');

      if (nav) {
        window.open(`/teacherDetailInfo.html?id=${this.teacherData.teacher_id || this.teacherData.id}&usercode=${this.teacherData.usercode}&name=${nav.nav_name}&menuId=${nav.id}`);
      }
    }

  }
};